import React from "react";
import { FREELANCER } from "../../Router/paths";
import { FaBriefcase, FaBuilding, FaHeart, FaLocationArrow, FaPlusCircle, FaUsers } from "react-icons/fa";
import { BsPencilSquare } from "react-icons/bs";
import TalentImg from '../../assets/images/talent-img.png'

export default function ConfirmHire() {
  return (
    <section className="talent-sec pc-p-3">
      <div className="conainter-fluid px-5">
        <div className="row">
          <div className="col-lg-3 col-md-3 col-12">
            <div className="talent-list">
              <ul>
                <li>
                  {" "}
                  <a href="javascript:void(0)">
                    {" "}
                    <FaLocationArrow />
                    Discover{" "}
                  </a>{" "}
                </li>
                <li>
                  {" "}
                  <a href="javascript:void(0)">
                    {" "}
                    <FaBriefcase /> Your
                    hires{" "}
                  </a>{" "}
                </li>
                {/* <li>
                  {" "}
                  <a href="javascript:void(0)">
                    {" "}
                    <FaBuilding /> Company
                    hires{" "}
                  </a>{" "}
                </li>
                <li>
                  {" "}
                  <a href="javascript:void(0)">
                    {" "}
                    <FaUsers /> bnr talent
                  </a>{" "}
                </li>
                <li>
                  {" "}
                  <a href="javascript:void(0)">
                    {" "}
                    <BsPencilSquare />
                    Recently reviewed{" "}
                  </a>{" "}
                </li> */}
              </ul>
            </div>
            <div className="talent-list mt-5">
              <h5>
                Your List <FaPlusCircle />
              </h5>
              <ul>
                <li>
                  {" "}
                  <a href="javascript:void(0)">
                    {" "}
                    <FaHeart /> Saved
                    talent{" "}
                  </a>{" "}
                </li>
                {/* <li>
                  {" "}
                  <a href="javascript:void(0)">
                    {" "}
                    <BsPencilSquare />
                    Saved Projects{" "}
                  </a>{" "}
                </li> */}
              </ul>
            </div>
          </div>
          <div className="col-lg-9 col-md-9 col-12">
            <div className="primary-heading color-dark">
              <h4>Your Hires</h4>
              <p>look up people you have saved</p>
            </div>
            <div className="row">
              <div className="col-lg-4 col-md-4 col-12">
                <div className="talent-box">
                  <div className="talent-img">
                    <img src={TalentImg} alt="Talent Image" />
                  </div>
                  <div className="talent-content">
                    <h4>Your next</h4>
                    <h5>superstar</h5>
                    <a href={FREELANCER.profile} className="p-link">
                      Review Your Hire
                    </a>
                  </div>
                  <a href="#" className="primary-btn color-light mt-3">
                    Pay with Stripe
                  </a>
                </div>
              </div>
              <div className="col-lg-4 col-md-4 col-12">
                <div className="talent-box">
                  <div className="talent-img">
                    <img src={TalentImg} alt="Talent Image" />
                  </div>
                  <div className="talent-content">
                    <h4>Your next</h4>
                    <h5>superstar</h5>
                    <a href="javascript:void(0)" className="p-link">
                      Review Your Hire
                    </a>
                  </div>
                  <a href="#" className="primary-btn color-light mt-3">
                    Pay with Stripe
                  </a>
                </div>
              </div>
              <div className="col-lg-4 col-md-4 col-12">
                <div className="talent-box">
                  <div className="talent-img">
                    <img src={TalentImg} alt="Talent Image" />
                  </div>
                  <div className="talent-content">
                    <h4>Your next</h4>
                    <h5>superstar</h5>
                    <a href="javascript:void(0)" className="p-link">
                      Review Your Hire
                    </a>
                  </div>
                  <a href="#" className="primary-btn color-light mt-3">
                    Pay with Stripe
                  </a>
                </div>
              </div>
            </div>
            <div className="primary-heading color-dark mt-3">
              <p>
                You haven't save anyone yet. Start saving to help you remember
                that talent caught your eye.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
